import React from 'react';

import { Text, Row, Icon, LoadingOutlined } from 'farmhub-ui-core';

import { PartnerNoteDescription } from 'api';
import { theme } from 'styled';
import { ICONS } from 'utils';

import PartnerNoteDescriptionEditor from './PartnerNoteDescriptionEditor';
import { Dot, PartnerDescriptionItemEditorWrapper } from './styles';

type PartnerNoteDescriptionItemProps = {
  data: PartnerNoteDescription;
  activeFormID: string | undefined;
  onUpdateDescription: (val: any) => Promise<void>;
  onDeleteDescription: (val: any) => Promise<void>;
  onActiveFormID: (val: string | undefined) => void;
};

const PartnerNoteDescriptionItem = ({
  data,
  activeFormID,
  onUpdateDescription,
  onDeleteDescription,
  onActiveFormID,
}: PartnerNoteDescriptionItemProps) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isEditMode, setIsEditMode] = React.useState(false);

  const handleUpdateDescription = async (val: any) => {
    await onUpdateDescription({
      ...data,
      value: val.description ?? data.value,
      action: 'update',
    });
    handleCancelEditMode();
  };

  const handleDeleteDescription = async () => {
    setIsLoading(true);
    await onDeleteDescription(data);
    setIsLoading(false);
  };

  const handleShowEditMode = () => {
    setIsEditMode(true);
    onActiveFormID(data.id);
  };

  const handleCancelEditMode = () => {
    setIsEditMode(false);
    onActiveFormID(undefined);
  };

  if (isEditMode && activeFormID == data.id) {
    return (
      <PartnerNoteDescriptionEditor
        description={data.value}
        onCancel={handleCancelEditMode}
        onSubmit={handleUpdateDescription}
      />
    );
  }

  return (
    <PartnerDescriptionItemEditorWrapper>
      <Row alignItems="flex-start" styles={{ gap: 8 }}>
        <Dot />
        <Text
          size="xxs"
          styles={{ cursor: 'pointer', width: '100%' }}
          onClick={handleShowEditMode}
        >
          {data.value}
        </Text>
      </Row>
      <Row
        className="note-description-action"
        styles={{ gap: 12, marginTop: '4px' }}
        width="fit-content"
      >
        {isLoading ? (
          <LoadingOutlined spin style={{ fontSize: 14 }} />
        ) : (
          <Icon
            styles={{ cursor: 'pointer' }}
            svgProps={{
              icon: ICONS.CLOSE,
              width: '12px',
              height: '12px',
              color: theme.colors.text.primary,
            }}
            tooltip="Xóa"
            onClick={handleDeleteDescription}
          />
        )}
      </Row>
    </PartnerDescriptionItemEditorWrapper>
  );
};

export default PartnerNoteDescriptionItem;
